var map = {
	"./EventAndPrevent.jfif": 488,
	"./ExamReview.jfif": 137,
	"./IslandSiege.png": 676,
	"./QuestionAI.jpg": 245,
	"./SurpriseDiscovery.jpg": 571,
	"./barteringSystem.jpg": 380,
	"./galaxy.jpg": 512,
	"./squirrelGame.PNG": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;